import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {CremaTheme} from '../../types/AppContextPropsType';
import {amber, green} from '@material-ui/core/colors';
import {SnackbarProvider as Provider} from 'notistack';

const useStyles = makeStyles((theme: CremaTheme) => ({
  variantSuccess: {
    backgroundColor: green[600] + ' !important',
    color: 'black !important',
  },
  variantError: {
    backgroundColor: theme.palette.error.dark + ' !important',
    color: 'black !important',
  },
  variantInfo: {
    backgroundColor: theme.palette.primary.main + ' !important',
    color: 'black !important',
  },
  variantWarning: {
    backgroundColor: amber[700] + ' !important',
    color: 'black !important',
  },
}));

const SnackbarProvider: React.FC<React.PropsWithChildren> = ({children}) => (
  <Provider classes={useStyles()}>{children}</Provider>
);

export default SnackbarProvider;
